/*
TODO: rename this to componentView
and update all the refs to it
*/
import $ from 'jquery';
import contextGet from './context.get';
import trigger from 'lib/analytics/trigger';
import combineBlocks from './combineBlocks';

export default function anComponentView(scope) {
  var $scope = $(scope);
  var localBlocks = Array.prototype.slice.call(arguments); // turn args into legit Arr
  localBlocks.shift(); // remove scope

  trigger('aa-component-view', [
    contextGet($scope),
    combineBlocks(localBlocks) // any blocks that come WITH a pageLoad must win over its context
  ]);
};
